<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped>
    <template #column-key-unitCost="{ value }">
      {{ value | money }}
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.projects.library.imputedCosts.edit', params: { imputedCostId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'costi-list-table',
  components: {
    AwlTable: () => import('../../../../libs/Table/components/AwlTable'),
    ActionDelete: () => import('../../Actions/ActionDelete'),
    ActionEdit: () => import('../../Actions/ActionEdit'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    costi: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'name', label: 'Nome' },
        { key: 'measurementUnit', label: 'Unità di misura' },
        { key: 'unitCost', label: 'Costo unitario' },
      ];
    },
    tableRows () {
      return (this.costi || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
